import React from "react";
import Project from "./projet";

export function ProjectPlanned() {
  return <Project status="Planifié" />;
}